import { render, staticRenderFns } from "./TransferReceiptVoucherEditView.vue?vue&type=template&id=f6f3e2c8"
import script from "./TransferReceiptVoucherEditView.vue?vue&type=script&lang=js"
export * from "./TransferReceiptVoucherEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports